// src/services/meetingRoomApi.js
import axios from "axios";

const ROOMS_CACHE_KEY = "meeting-rooms:rooms:v1";
const ROOMS_CACHE_TTL_MS = 30 * 60 * 1000;

const BASE_URL =
  process.env.REACT_APP_MEETING_API_URL || "http://localhost:5000";

const http = axios.create({
  baseURL: `${BASE_URL}/api`,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fetchRooms = async () => {
  const res = await http.get("/meeting-rooms/rooms");
  return res.data;
};

export const fetchTodayAvailability = async () => {
  const res = await http.get("/meeting-rooms/availability/today");
  return res.data;
};

export const getCachedRooms = () => {
  try {
    const raw = sessionStorage.getItem(ROOMS_CACHE_KEY);
    if (!raw) return null;

    const cached = JSON.parse(raw);
    if (
      !Array.isArray(cached?.rooms) ||
      Date.now() - cached.cachedAt > ROOMS_CACHE_TTL_MS
    ) {
      sessionStorage.removeItem(ROOMS_CACHE_KEY);
      return null;
    }

    return cached.rooms;
  } catch (error) {
    console.warn("Unable to read cached meeting rooms", error);
    return null;
  }
};

export const cacheRooms = (rooms) => {
  try {
    sessionStorage.setItem(
      ROOMS_CACHE_KEY,
      JSON.stringify({ rooms, cachedAt: Date.now() })
    );
  } catch (error) {
    console.warn("Unable to cache meeting rooms", error);
  }
};

export const fetchBookings = async ({ roomId, dateKey }) => {
  const res = await http.get("/meeting-rooms/bookings", {
    params: { roomId, dateKey },
  });
  return res.data;
};

export const fetchBookingsByDateRange = async ({
  roomId,
  startDate,
  endDate,
}) => {
  const res = await http.get("/meeting-rooms/bookings", {
    params: { roomId, startDate, endDate },
  });
  return res.data;
};

export const fetchMyBookings = async ({ roomId, dateKey }) => {
  const res = await http.get("/meeting-rooms/bookings/mine", {
    params: { roomId, dateKey },
  });
  return res.data;
};

export const createBooking = async (payload) => {
  const res = await http.post("/meeting-rooms/bookings", payload);
  return res.data;
};

export const updateBooking = async (id, payload) => {
  const res = await http.patch(`/meeting-rooms/bookings/${id}`, payload);
  return res.data;
};

export const deleteBooking = async (id) => {
  const res = await http.delete(`/meeting-rooms/bookings/${id}`);
  return res.data;
};
